import React, { FC, useContext, useEffect, useRef, useState } from "react";
import cn from "clsx";
import { useTranslation } from "react-i18next";
import { productErrorContext } from "./productWebSizes";
import ProductSizeFormatMessages from "@/routes/pdp/productSizeGeneralComponents/productSizeFormatMessages";
import { ProductSizeDetailsProps } from "./types";

const SHOW_VIEW_MORE_THRESHOLD = 180;

const ProductSizeDetails: FC<ProductSizeDetailsProps> = ({
  productDetails,
  children
}) => {
  const [expandabilityEnabled, setExpandabilityEnabled] = useState(false);
  const [viewMoreExpanded, setViewMoreExpanded] = useState(false);
  const [collapsedHeight, setCollapsedHeight] = useState(0);
  const [expandedHeight, setExpandedHeight] = useState(0);
  const { selectSizeFirstError: showErrorBorder } =
    useContext(productErrorContext);
  const { t } = useTranslation("productDetails");
  const sizeContainerRef = useRef(null);

  const toggleViewMoreDetails = () => {
    setViewMoreExpanded(!viewMoreExpanded);
  };

  useEffect(() => {
    const sizesContainerHeight = sizeContainerRef?.current?.clientHeight || 0;

    if (sizesContainerHeight > SHOW_VIEW_MORE_THRESHOLD) {
      setExpandabilityEnabled(true);
      const allSizesHeight =
        sizeContainerRef?.current.childNodes[0].clientHeight || 0;

      if (sizesContainerHeight !== 0 && allSizesHeight !== 0) {
        setCollapsedHeight(SHOW_VIEW_MORE_THRESHOLD + 30);
        setExpandedHeight(allSizesHeight + 80);
      }
    }
  }, [productDetails]);

  const sizesContainerHeight = viewMoreExpanded
    ? expandedHeight
    : collapsedHeight;

  return (
    <>
      <div className="view_product_quality_outer">
        <div
          ref={sizeContainerRef}
          className={cn("view_product_quality", "view_more_sizes", {
            expand: viewMoreExpanded,
            size_selection_error: showErrorBorder
          })}
          {...(showErrorBorder &&
            !expandabilityEnabled && { style: { maxHeight: "unset" } })}
          {...(expandabilityEnabled && {
            style: {
              height: sizesContainerHeight,
              maxHeight: sizesContainerHeight
            }
          })}
        >
          {children}
          {expandabilityEnabled && (
            <p className="view_more">
              <span onClick={toggleViewMoreDetails}>
                {t(viewMoreExpanded ? "ShowLessSizes" : "ShowAllSizes")}
              </span>
            </p>
          )}
        </div>
      </div>
      <ProductSizeFormatMessages
        productHighlights={productDetails?.highlights}
        containerClassName="desktop_view mt-2"
      />
    </>
  );
};

export default ProductSizeDetails;
